<template src="./Checkout.html">

</template>

<script>
import { getRoute } from '@/services/routes'
import {
  postPassenger,
  validateCheckout,
  validateBusCharter
} from '@/services/passenger'
import { makePayment } from '@/services/transaction'
import { format } from 'date-fns'
import PassengerItem from './PassengerItem'

const validateForm = (formData) => {
  let isValid = true
  Object.keys(formData).forEach(item => {
    if (!(formData[item]) && item !== 'others') {
      isValid = false
    }
  })
  return isValid
}

export default {
  name: 'checkout',
  data () {
    return {
      validating: true,
      estimatedAmount: 0,
      isValid: false,
      hasAcceptedTerms: false,
      isCharter: false,
      realDate: null,
      includeTrainTrip: false,
      passengers: 1,
      passengerRoute: {
        from_loc: {},
        to_loc: {}
      },
      showPaymentForm: true,
      loading: false,
      paymentInfo: {
        public_key: '',
        amount: '',
        ref: ''
      },
      model: {
        email: '',
        nok_name: '',
        nok_tel_no: '',
        tel_no: '',
        others: []
      }
    }
  },
  computed: {
    passengersCount () {
      return parseInt(this.$route.query.passengers)
    },

    selectedSeatsNos () {
      if (this.isCharter) {
        return 'Bus Charter'
      }
      return this.$route.query.selectedSeats
    },

    depatureDate () {
      return format(this.realDate, 'YYYY-MM-DD')
    },

    computedTravelDate () {
      return format(this.realDate, 'ddd MMM YYYY')
    },

    computedPayableAmount () {
      // TODO if it is charterd just return 19000
      if (this.isCharter) {
        return 19000
      }
      const passengers = this.$route.query.passengers || 1
      const amt = (this.passengerRoute.amount * passengers)
      // TODO only apply bonusFactor to 2 passenger
      const bonusFactor = passengers > 1 ? (passengers - 1) * 500 : 0
      return amt - bonusFactor
    }

  },

  components: {
    PassengerItem
  },

  watch: {
    '$route' (to, from) {
      const queryParam = to.query
      this.isCharter = queryParam.isCharter
      if (queryParam.isCharter) {
        this.checkCharterAvailability(queryParam)
      } else {
        this.validateCheckoutPage(queryParam)
      }
    }
  },

  mounted () {
    this.loadRoute()
  },

  methods: {
    loadRoute () {
      const selectedRoute = this.$route.query.loc_route
      getRoute(selectedRoute)
        .then(res => {
          this.passengerRoute = res.data
          const queryParams = this.$route.query
          this.isCharter = queryParams.isCharter
          if (queryParams.isCharter) {
            this.checkCharterAvailability(queryParams)
          } else {
            this.validateCheckoutPage(queryParams)
          }
        })
        .catch(err => {
          // TODO redirect to no route selected page
          console.log(err)
        })
    },

    checkCharterAvailability (queryParam) {
      this.realDate = new Date(parseInt(queryParam.departure_date))
      this.isValid = false
      this.validating = true

      const loading = this.$loading({
        lock: true,
        text: 'Validating bus charter.....',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const depDate = format(this.realDate.toString())
      const query = {
        route: queryParam.loc_route,
        dep_date: depDate
      }
      validateBusCharter(query)
        .then(res => {
          loading.close()
          const canCharter = res.data.result
          this.isValid = canCharter
          this.validating = false
          this.estimatedAmount = this.passengerRoute.charter_amount
        })
        .catch(() => {
          loading.close()
          this.isValid = false
          this.validating = true
          this.$notify.error({
            title: 'Bus Charter',
            message: 'Could not find bus.\nPlease try again.'
          })
        })
    },

    validateCheckoutPage (queryParam) {
      this.realDate = new Date(parseInt(queryParam.departure_date))

      const urlInfo = {
        dep_date: format(this.realDate),
        seats: queryParam.selectedSeats,
        route: queryParam.loc_route,
        passengers: queryParam.passengers,
        route_section: queryParam.route_section || 0
      }
      this.isValid = false
      this.validating = true

      validateCheckout(urlInfo)
        .then(res => {
          this.isValid = true
          this.validating = false
          if (this.isCharter) {
            this.estimatedAmount = res.data.charter_amount
          } else {
            this.estimatedAmount = res.data.amount
          }
        })
        .catch(err => {
          this.isValid = false
          this.validating = true
          this.$notify.error({
            title: 'Checkout Details',
            message: err.response.data
          })
        })
    },

    payWithPaystack (paymentInfo) {
      const formElem = this.$refs.paystackForm
      // TODO check if the script has been loaded before
      let payStackInline = document.createElement('script')
      payStackInline.setAttribute('id', 'rrPaystack')
      payStackInline.onload = () => {
        this.lunchPaystackPopup(paymentInfo)
      }
      payStackInline.setAttribute('src', 'https://js.paystack.co/v1/inline.js')
      formElem.appendChild(payStackInline)
    },

    lunchPaystackPopup (paymentInfo) {
      const pubKey = paymentInfo.pub_key
      const chargeableAmount = paymentInfo.amount
      const tranRef = paymentInfo.ref
      const email = this.model.email || 'payment@railroad.ng'
      let handler = window.PaystackPop.setup({
        key: pubKey,
        email: email,
        amount: chargeableAmount * 100,
        ref: tranRef,
        metadata: {
        "custom_fields": [
              {
                "display_name": "Phone Number",
                "variable_name": "phone_number",
                "value": this.model.tel_no
              }]
        },
        callback: (response) => {
          this.onPaystackSuccess()
        },
        onClose: () => {
          this.$message.error('You cancel your payment. \n Click pay again to continue')
          this.loading = false
        }
      })
      handler.openIframe()
    },

    validateOthers () {
      let isValid = true
      this.model.others.forEach(item => {
        if (item.full_name === '' || (!item.gender)) {
          isValid = false
        }
      })
      return isValid
    },

    handlePayNow () {
      if (!validateForm(this.model)) {
        this.$message('Fill all required field ')
        return
      }

      if (!this.validateOthers()) {
        this.$notify.error({
          'message': 'Fill all passenger information'
        })
        return
      }
      const customerDetails = JSON.stringify(this.formatPayload())
      const data = {
        seat_nos: this.selectedSeatsNos,
        route: this.passengerRoute.id,
        train_inclusive: this.includeTrainTrip,
        nos_passengers: this.passengersCount,
        is_charter: this.isCharter,
        customer_details: customerDetails,
        dep_date: format(this.realDate)
      }
      this.loading = true
      makePayment(data)
        .then(res => {
          this.loading = false
          this.paymentInfo = res.data
          this.payWithPaystack(res.data)
        })
        .catch(() => {
          this.loading = false
          this.$notify.warning('Oopp something went wrong when intializing payment')
        })
    },

    formatPayload () {
      const queryParams = this.$route.query
      const details = [...this.model.others]
      const firstPerson = details.shift() // set the first passenger info to the main contact
      const seats = this.paymentInfo.seats || this.selectedSeatsNos
      const passengerInfo = {
        ...this.model,
        ...firstPerson,
        others: details,
        // charter takes all the seats
        seat_nos: this.isCharter ? '1,2,3,4,5,6' : seats,
        is_charter: this.isCharter,
        route: this.passengerRoute.id,
        ref: this.paymentInfo.ref,
        dep_date: this.depatureDate,
        include_train_trip: this.includeTrainTrip,
        route_section: queryParams.route_section || 0
      }
      return passengerInfo
    },

    handlePaystackSuccess () {

    },

    onPaystackSuccess () {
      const passengerInfo = this.formatPayload()
      postPassenger(passengerInfo)
        .then(res => {
          this.$notify.success({
            message: 'Payment successfull!!!\nPreparing your reciept'
          })
          this.$router.push({ name: 'PrintPage', query: { ref: passengerInfo.ref } })
        })
        .catch(err => {
          this.$notify.error({
            message: err.response.data
          })
        })
    }
  }
}
</script>

<style lang="scss" src="./checkout.scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/checkout/Checkout.vue